import { TooltipType } from 'type/tooltips';

export const getTooltip = (title: string, tooltips: TooltipType[]) => {
  const tooltip = tooltips?.filter((tt) => {
    return tt?.solutionTitles
      .map((t) => t?.toLowerCase())
      .includes(title.toLowerCase());
  });

  if (tooltip?.length > 0) {
    return tooltip[0];
  }

  return;
};
